import { utils } from 'utils';
import {
  fetchUserData,
  setDataDogUser,
  setUserLanguage,
} from '../../login/helpers';
import { reportErrorToDataDog } from '../../../utils/datadog';

export const trackSuccessfulLogin = accessToken => {
  const userId = accessToken?.claims?.userId;

  if (!userId) {
    const error = new Error('Cannot track login: missing userId in access token');
    reportErrorToDataDog(error.message, {
      errorLocation: 'userEnrichmentService.trackSuccessfulLogin',
      accessTokenExists: Boolean(accessToken),
      claimsExist: Boolean(accessToken?.claims),
    });
    return;
  }

  utils.eventsLogger.unifiedLoginDio.track('logged_successfully', 'submit', {
    userId,
  });
};

export const extractAndPersistUserData = accessToken => {
  if (!accessToken?.accessToken) {
    const error = new Error('Cannot persist user data: missing access token');
    console.error(error.message);
    reportErrorToDataDog(error.message, {
      errorLocation: 'userEnrichmentService.extractAndPersistUserData',
      accessTokenExists: Boolean(accessToken),
    });
    return;
  }

  utils.saveUserData(accessToken.accessToken);
};

export const enrichUserData = async () => {
  const isHq = utils.isHQDomain;
  const user = await fetchUserData({ enrichUser: true, isHq });

  await setDataDogUser({ user, isHq });
  setUserLanguage(user?.displayLanguage);

  return user;
};
